<template>
  <b-alert
    v-if="visible"
    show
    :variant="variant"
    class="network-status-banner mb-0 rounded-0 shadow-sm"
  >
    <div class="network-status-banner__content">
      <feather-icon
        :icon="icon"
        size="18"
        class="network-status-banner__icon flex-shrink-0"
      />
      <span class="network-status-banner__message">
        <strong>{{ $t(titleKey) }}</strong>
        {{ $t(descriptionKey) }}
      </span>
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import { networkStatus } from '@/helpers/networkStatus'

export default {
  name: 'NetworkStatusBanner',
  components: { BAlert },
  computed: {
    status() {
      return networkStatus.status
    },
    visible() {
      return ['offline', 'unstable'].includes(this.status)
    },
    variant() {
      return this.status === 'offline' ? 'danger' : 'warning'
    },
    icon() {
      return this.status === 'offline' ? 'WifiOffIcon' : 'AlertTriangleIcon'
    },
    titleKey() {
      return `network.banner.${this.status}.title`
    },
    descriptionKey() {
      return `network.banner.${this.status}.description`
    },
  },
}
</script>

<style lang="scss" scoped>
.network-status-banner {
  position: relative;
  z-index: 1;
  padding: 0.55rem 1rem;
  line-height: 1.35;
  margin-top: -1rem;
}

.network-status-banner__content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  min-height: 1.5rem;
  text-align: center;
}

.network-status-banner__icon {
  margin-right: 0.5rem;
}

.network-status-banner__message {
  overflow-wrap: anywhere;
}

@media (max-width: 575.98px) {
  .network-status-banner {
    padding: 0.6rem 0.75rem;
  }

  .network-status-banner__content {
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
  }
}
</style>
